/* eslint-disable */ import { attachSingleReferenceComponent, detailComponent, memoEval, referenceComponent, sceneEntityObjectPropertiesComponent, sceneEntityPropertiesComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Wall } from '../model/index.js';
export const countertopWallItemComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('CountertopWallItem').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'CountertopWallItem.$wall', true).withAlias('CountertopWallItem'), Wall, 'wallId'),
    attachComponent.withComponent(detailComponent, 'default', true).withAlias('CountertopWallItem').attach(memoEval((self)=>[
            self.$name,
            self.$sku,
            self.$description,
            self.$thumbnailUrl
        ], ($name, $sku, $description, $thumbnailUrl)=>({
            title: $name,
            subtitle: $sku,
            description: $description,
            thumbnailUrl: $thumbnailUrl
        }))),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('CountertopWallItem').attach(memoEval((self)=>[
            self.x,
            self.$offsetZ
        ], (x, $offsetZ)=>({
            offsetX: x,
            offsetZ: $offsetZ
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withAlias('CountertopWallItem').attach(memoEval((self)=>[
            self.$offsetX,
            self.$offsetY
        ], ($offsetX, $offsetY)=>({
            offsetX: $offsetX,
            offsetY: $offsetY
        })))
];

//# sourceMappingURL=countertop-wall-item.js.map